import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';

import { AttachmentModel } from './models/attachment';

@Component({
  selector   : 'wor-attachment-video-viewer',
  template: require('./attachment.video-viewer.component.html')
})
export class VideoViewerComponent {
  videoSource: SafeResourceUrl;

  private _video: AttachmentModel;

  @Input() set video ( value: AttachmentModel ) {
    this._video      = value;
    this.videoSource = this.sanitizer.bypassSecurityTrustResourceUrl(value.attachment_url);
  }

  get video () : AttachmentModel {
    return this._video;
  }

  constructor (
    public  activeModal: NgbActiveModal,
    private sanitizer  : DomSanitizer
  ) {}
}
